<template>
  <v-tour
    name="C3Tour"
    :steps="
      ((auth || {}).user || {}).isVendor
        ? tour.vendorTourSteps
        : tour.userTourSteps
    "
    :callbacks="tour.tourCallbacks"
    :options="{ highlight: true }"
  ></v-tour>
</template>
<script>
import { mapState } from "vuex";
import Auth from "@/auth.js";
import $ from "jquery";

export default {
  name: "AppTour",
  data() {
    return {
      tourStarted: false,
      tour: {
        tourCallbacks: {
          onStop: this.onTourExit,
        },
        vendorTourSteps: [
          {
            target: '[data-v-step="myAccount"]',
            header: {
              title: "Get Started",
            },
            content: `Click Next for a quick guide on how to easily navigate through C3 App.`,
            before: (type) =>
              new Promise((resolve) => {
                if (this.isMobileTablet && type != "previous") {
                  setTimeout(() => {
                    $('[data-v-step="mainHeaderMenu"]')[0].click();
                    resolve();
                  }, 1000);
                } else {
                  resolve();
                }
              }),
          },
          {
            target: '[data-v-step="editVendorProfile"]',
            header: {
              title: "Vendors Profile",
            },
            content: `Check and see your vendors information from here.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "previous" && this.isMobileTablet) {
                  $('[data-v-step="mainHeaderMenu"]')[0].click();
                }
                setTimeout(() => {
                  $('[data-v-step="myAccount"]').click();
                  resolve();
                }, 10);
              }),
          },
          {
            target: '[data-v-step="editVendorProfile_0"]',
            header: {
              title: "Vendors Profile",
            },
            content: `View and Edit your vendors information from here.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="editVendorProfile"]')[0].click();
                  const interval = setInterval(() => {
                    if ($('[data-v-step="editVendorProfile_0"]')[0]) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 10);
                } else {
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 0);
                  const interval = setInterval(() => {
                    if ($('[data-v-step="editVendorProfile_0"]')[0]) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 10);
                }
              }),
          },
          {
            target: '[data-v-step="vendorProfile"]',
            header: {
              title: "Profile",
            },
            content: `Keep your vendor profile updated`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="editVendorProfile_0"]')[0].click();
                  const interval = setInterval(() => {
                    if ($(this.tour.vendorTourSteps[3].target)[0]) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                } else {
                  resolve();
                }
              }),
          },
          {
            target: '[data-v-step="inviteVendor"]',
            header: {
              title: "Invite User",
            },
            content: `Invite your friends as a vendor to join the site.`,
          },
          {
            target: '[data-v-step="vendorLogos"]',
            header: {
              title: "Logo",
            },
            content: `Upload your vendor’s logo here.`,
          },
          {
            target: '[data-v-step="vendorServices"]',
            header: {
              title: "Services/Specialties",
            },
            content: `Specify your services and specialties here.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "previous") {
                  this.$router.go(-1);
                  const interval = setInterval(() => {
                    if ($('[data-v-step="vendorServices"]')[0]) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                } else {
                  resolve();
                }
              }),
          },
          {
            target: '[data-v-step="vendorLocations"]',
            header: {
              title: "Locations",
            },
            content: `Add one or more locations for your clinics/facilities.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="vendorLocations"]')[0].click();
                  setTimeout(() => {
                    resolve();
                  }, 0);
                } else {
                  this.$router.go(-1);
                  setTimeout(() => {
                    resolve();
                  }, 10);
                }
              }),
          },
          {
            target: '[data-v-step="vendorContacts"]',
            header: {
              title: "Contacts",
            },
            content: `Add one or more contacts for your clinic/facility/professional, at least one should be primary to maintain vendor profile.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="vendorContacts"]')[0].click();
                  setTimeout(() => {
                    resolve();
                  }, 0);
                } else {
                  this.$router.go(-1);
                  setTimeout(() => {
                    resolve();
                  }, 10);
                }
              }),
          },
          {
            target: '[data-v-step="vendorBillings"]',
            header: {
              title: "Billing",
            },
            content: `Feature that will be released soon!`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="vendorBillings"]')[0].click();
                  setTimeout(() => {
                    resolve();
                  }, 0);
                } else {
                  this.$router.go(-1);
                  setTimeout(() => {
                    resolve();
                  }, 10);
                }
              }),
          },
          {
            target: '[data-v-step="vendorIntakeForm"]',
            header: {
              title: "Intake Form",
            },
            content: `Upload your PDF intake form for clients to download & use it as needed.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="vendorIntakeForm"]')[0].click();
                  setTimeout(() => {
                    resolve();
                  }, 0);
                } else {
                  this.$router.go(-1);
                  setTimeout(() => {
                    resolve();
                  }, 10);
                }
              }),
          },
          {
            target: '[data-v-step="vendorNetwork"]',
            header: {
              title: "Vendor Network",
            },
            content: `Vendor network connections and requests.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="vendorNetwork"]')[0].click();
                  setTimeout(() => {
                    resolve();
                  }, 0);
                } else {
                  this.$router.go(-1);
                  setTimeout(() => {
                    resolve();
                  }, 10);
                }
              }),
          },
          {
            target: '[data-v-step="vendorNetworkRequests"]',
            header: {
              title: "Network Requests",
            },
            content: `The network connection requested from other vendors, Once you approve the requests you will be part of their network`,
            before: (type) =>
              new Promise((resolve) => {
                if (type != "next") {
                  this.$router.go(-1);
                }
                setTimeout(() => {
                  resolve();
                }, 10);
              }),
          },
          {
            target: '[data-v-step="myNetwork"]',
            header: {
              title: "My Network",
            },
            content: `Your network connections have been approved by other vendors`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="myNetwork"]')[0].click();
                  setTimeout(() => {
                    resolve();
                  }, 0);
                } else {
                  this.$router.go(-1);
                  setTimeout(() => {
                    resolve();
                  }, 10);
                }
              }),
          },
          {
            target: '[data-v-step="vendorFollowers"]',
            header: {
              title: "Followers",
            },
            content: `The users following this vendor.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="vendorFollowers"]')[0].click();
                  setTimeout(() => {
                    resolve();
                  }, 0);
                } else {
                  if (this.isMobileTablet) {
                    $('[data-v-step="mainHeaderMenu"]')[0].click();
                  }
                  if ($('[data-v-step="vendorFollowers"]')[0]) {
                    resolve();
                  } else {
                    this.$router.go(-1);
                    const interval = setInterval(() => {
                      if ($('[data-v-step="vendorFollowers"]')[0]) {
                        clearInterval(interval);
                        resolve();
                      }
                    }, 100);
                  }
                }
              }),
          },
          {
            target: '[data-v-step="myReferrals"]',
            header: {
              title: "Referrals",
            },
            content: `Check sent and received referrals.`,
            before: () =>
              new Promise((resolve) => {
                if (this.isMobileTablet) {
                  $('[data-v-step="mainHeaderMenu"]')[0].click();
                }
                resolve();
              }),
          },
          {
            target: '[data-v-step="sentReferrals"]',
            header: {
              title: "Sent Referrals",
            },
            content: `All referrals initiated by you to other vendors.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="myReferrals"]')[0].click();
                  const interval = setInterval(() => {
                    if ($('[data-v-step="sentReferrals"]')[0]) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                } else {
                  this.$router.go(-1);
                  setTimeout(() => {
                    resolve();
                  }, 100);
                }
              }),
          },
          {
            target: '[data-v-step="receivedReferrals"]',
            header: {
              title: "Received Referrals",
            },
            content: `All referrals sent to you by other vendors/users.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="receivedReferrals"]')[0].click();
                  setTimeout(() => {
                    resolve();
                  }, 0);
                } else {
                  if (this.isMobileTablet) {
                    $('[data-v-step="mainHeaderMenu"]')[0].click();
                  }
                  if (!$('[data-v-step="receivedReferralsHeader"]')[0]) {
                    this.$router.go(-1);
                  }
                  const interval = setInterval(() => {
                    if ($('[data-v-step="receivedReferrals"]')[0]) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                }
              }),
          },
          {
            target: '[data-v-step="inviteUser"]',
            header: {
              title: "Invite User",
            },
            content: `Invite your friends to join the site.`,
            before: (type) =>
              new Promise((resolve) => {
                if (this.isMobileTablet && type == "next") {
                  $('[data-v-step="mainHeaderMenu"]')[0].click();
                }
                resolve();
              }),
          },
          {
            target: '[data-v-step="vendorMap"]',
            header: {
              title: "Vendors Map",
            },
            content: `Find all vendors in your area.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type != "next") {
                  $('[data-v-step="mainHeaderMenu"]')[0].click();
                }
                resolve();
              }),
          },
          {
            target: '[data-v-step="vendorMapSearch"]',
            header: {
              title: "Vendors Search",
            },
            content: `Flexible search for specific vendors by multiple criteria.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="vendorMap"]')[0].click();
                  const interval = setInterval(() => {
                    if ($('[data-v-step="vendorMapSearch"]')[0]) {
                      $('[data-v-step="vendorMapSearch"]')[0].focus();
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                } else {
                  $('[data-v-step="vendorMapSearch"]')[0].focus();
                  resolve();
                }
              }),
          },
          {
            target: '[data-v-step="searchCity"]',
            header: {
              title: "Search By City",
            },
            content: `Switch to search for vendors in specific city/area.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type != "next") {
                  if ($('[data-v-step="vendorMapSearch"]')[0]) {
                    $('[data-v-step="vendorMapSearch"]')[0].focus();
                    setTimeout(() => {
                      $('[data-v-step="vendorMapSearch"]')[0].focus();
                    }, 100);
                  }
                  resolve();
                } else {
                  $('[data-v-step="vendorMapSearch"]')[0].focus();
                  resolve();
                }
              }),
          },
          {
            target: '.vendor-card-2 [data-v-step="connectWithVendor"]',
            header: {
              title: "View/Connect with Vendor",
            },
            content: `View vendor profile and initiate a referral to them if applicable.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  const interval = setInterval(() => {
                    if (
                      $('.vendor-card-2 [data-v-step="connectWithVendor"]')[0]
                    ) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                } else {
                  resolve();
                }
              }),
          },
          {
            target: '.vendor-card-2 [data-v-step="addToNetwork"]',
            header: {
              title: "Add To Network",
            },
            content: `Send a request to add the vendor to your network connections.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  const interval = setInterval(() => {
                    if ($('.vendor-card-2 [data-v-step="addToNetwork"]')[0]) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                } else {
                  resolve();
                }
              }),
          },
        ],
        userTourSteps: [
          {
            target: '[data-v-step="myAccount"]',
            header: {
              title: "Get Started",
            },
            content: `Click Next for a quick guide on how to easily navigate through C3 App.`,
            before: (type) =>
              new Promise((resolve) => {
                if (this.isMobileTablet && type != "previous") {
                  setTimeout(() => {
                    $('[data-v-step="mainHeaderMenu"]')[0].click();
                    resolve();
                  }, 1000);
                } else {
                  resolve();
                }
              }),
          },
          {
            target: '[data-v-step="editClientProfile"]',
            header: {
              title: "User Profile",
            },
            content: `Check and edit your profile information from here.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "previous" && this.isMobileTablet) {
                  $('[data-v-step="mainHeaderMenu"]')[0].click();
                }
                setTimeout(() => {
                  $('[data-v-step="myAccount"]').click();
                  resolve();
                }, 0);
              }),
          },
          {
            target: '[data-v-step="clientAccountContainer"]',
            header: {
              title: "Your Account",
            },
            content: `Update your account information.`,
            before: () =>
              new Promise((resolve) => {
                $('[data-v-step="editClientProfile"]')[0].click();
                const interval = setInterval(() => {
                  if ($('[data-v-step="clientAccountContainer"]')[0]) {
                    clearInterval(interval);
                    resolve();
                  }
                }, 100);
              }),
          },
          {
            target: '[data-v-step="myReferrals"]',
            header: {
              title: "Referrals",
            },
            content: `Check sent referrals.`,
            before: () =>
              new Promise((resolve) => {
                if (this.isMobileTablet) {
                  $('[data-v-step="mainHeaderMenu"]')[0].click();
                  resolve();
                } else {
                  resolve();
                }
              }),
          },
          {
            target: '[data-v-step="sentReferrals"]',
            header: {
              title: "Sent Referrals",
            },
            content: `All referrals initiated by you to other vendors.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="myReferrals"]')[0].click();
                  const interval = setInterval(() => {
                    if ($('[data-v-step="sentReferrals"]')[0]) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                } else {
                  $('[data-v-step="myReferrals"]')[0].click();
                  const interval = setInterval(() => {
                    if ($('[data-v-step="sentReferrals"]')[0]) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                }
              }),
          },
          {
            target: '[data-v-step="inviteUser"]',
            header: {
              title: "Invite User",
            },
            content: `Invite your friends to join the site.`,
            before: (type) =>
              new Promise((resolve) => {
                if (this.isMobileTablet && type == "next") {
                  $('[data-v-step="mainHeaderMenu"]')[0].click();
                }
                resolve();
              }),
          },
          {
            target: '[data-v-step="vendorMap"]',
            header: {
              title: "Vendors Map",
            },
            content: `Find all vendors in your area.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type != "next") {
                  $('[data-v-step="mainHeaderMenu"]')[0].click();
                }
                resolve();
              }),
          },
          {
            target: '[data-v-step="vendorMapSearch"]',
            header: {
              title: "Vendors Search",
            },
            content: `Flexible search for specific vendors by multiple criteria.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="vendorMap"]')[0].click();
                  const interval = setInterval(() => {
                    if ($('[data-v-step="vendorMapSearch"]')[0]) {
                      $('[data-v-step="vendorMapSearch"]')[0].focus();
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                } else {
                  $('[data-v-step="vendorMapSearch"]')[0].focus();
                  resolve();
                }
              }),
          },
          {
            target: '[data-v-step="searchCity"]',
            header: {
              title: "Search By City",
            },
            content: `Switch to search for vendors in specific city/area.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type != "next") {
                  if ($('[data-v-step="vendorMapSearch"]')[0]) {
                    $('[data-v-step="vendorMapSearch"]')[0].focus();
                  }
                  resolve();
                } else {
                  $('[data-v-step="vendorMapSearch"]')[0].focus();
                  resolve();
                }
              }),
          },
          {
            target: '.vendor-card-2 [data-v-step="connectWithVendor"]',
            header: {
              title: "View/Connect with Vendor",
            },
            content: `View vendor profile and initiate a referral to them if applicable.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  const interval = setInterval(() => {
                    if (
                      $('.vendor-card-2 [data-v-step="connectWithVendor"]')[0]
                    ) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                } else {
                  $('[data-v-step="vendorMap"]')[0].click();
                  const interval = setInterval(() => {
                    if (
                      $('.vendor-card-2 [data-v-step="connectWithVendor"]')[0]
                    ) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                }
              }),
          },
          {
            target: '[data-v-step="becomeVendor"]',
            header: {
              title: "Become a Vendor",
            },
            content: `Submit more information to register as a vendor profile.`,
            before: () => {
              new Promise((resolve) => {
                if (this.isMobileTablet) {
                  $('[data-v-step="mainHeaderMenu"]')[0].click();
                }
                resolve();
                setTimeout(() => {
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                  });
                }, 100);
              });
            },
          },
          {
            target: '[data-v-step="becomeVendorContainer"]',
            header: {
              title: "Become a Vendor",
            },
            content: `Fill information and send request to become one of C3 vendors.`,
            before: (type) =>
              new Promise((resolve) => {
                if (type == "next") {
                  $('[data-v-step="becomeVendor"]')[0].click();
                  const interval = setInterval(() => {
                    if ($('[data-v-step="becomeVendorContainer"]')[0]) {
                      clearInterval(interval);
                      resolve();
                    }
                  }, 100);
                } else {
                  resolve();
                }
              }),
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["auth"]),
    isMobileTablet: function () {
      return window.innerWidth <= 992;
    },
  },
  mounted() {
    if (
      this.auth &&
      this.auth.authenticated &&
      !Auth.tour.get(this.auth.user.id) &&
      this.auth.user &&
      (this.auth.user.isClient || this.auth.user.isVendor) &&
      !this.tourStarted
    ) {
      this.$tours["C3Tour"].start();
      this.tourStarted = true;
    }
  },
  watch: {
    "auth.authenticated": function () {
      if (
        this.auth &&
        this.auth.authenticated &&
        this.auth.user &&
        !this.tourStarted &&
        (this.auth.user.isVendor || this.auth.user.isUser)
      ) {
        this.$tours["C3Tour"].start();
        this.tourStarted = true;
      }
    },
  },
  methods: {
    onTourExit: function () {
      Auth.tour.set(this.auth.user.id);
    },
  },
};
</script>
